import { useEffect, useState } from "react";
import CloseIcon from "components/icons-svg/CloseIcon";
import CVADrawer from "components/modals/common/CVADrawer";
import DrawerFooterButtons from "components/searchBar/mobile-tablet-view/drawer-buttons/DrawerFooterButtons";
import { useMarkLocalSearchUpdate } from "components/searchBar/mobile-tablet-view/drawer-buttons/useMarkLocalSearchUpdate";
import CalenderAccordian from "components/searchBar/mobile-tablet-view/SearchCalender/CalenderAccordian";
import GuestAccordian from "components/searchBar/mobile-tablet-view/SearchGuest/GuestAccordian";
import LocationAccordian from "components/searchBar/mobile-tablet-view/SearchLocation/LocationAccordian";
import { useAppSelector } from "stores/hooks";
import { selectSearch } from "stores/search/searchSlice";
const MobileSearchDrawer = ({
  isOpen,
  onClose,
  pageOrigin
}: {
  isOpen: boolean;
  onClose: () => void;
  pageOrigin: string;
}) => {
  const search = useAppSelector(selectSearch);
  const markLocalSearchUpdate = useMarkLocalSearchUpdate(); // update the search state when drawer is closed
  const [isSearchCleared, setIsSearchCleared] = useState(false);
  const [isDateCleared, setIsDateCleared] = useState(false);
  useEffect(() => {
    if (!isOpen) return;
    setTimeout(() => {
      void (async () => {
        const mixpanelV2Client = (await import("services/mixpanelv2")).mixpanelV2Client;
        mixpanelV2Client.CLICK_OPEN_SEARCH({
          pageOrigin: pageOrigin || "search results page",
          actionType: pageOrigin === "search results page" ? "modify" : "initial"
        });
      })();
    }, 0);
  }, [isOpen, pageOrigin]);
  return <CVADrawer isOpen={isOpen} onClose={onClose} intent={"top"} size={"fullScreen"} isCloseIcon={false} className='bg-offWhite px-0 pt-8' data-sentry-element="CVADrawer" data-sentry-component="MobileSearchDrawer" data-sentry-source-file="MobileSearchDrawer.tsx">
      <header className='relative z-[1000] pb-6 pl-8 pr-4'>
        <div className='flex items-center justify-between'>
          {/* Custom close icon that triggers the onClose function */}
          <p className='text-lg font-semibold leading-[18px] tracking-[-0.18px] text-brand-dark'>
            Find your next stay
          </p>
          <button onClick={() => {
          onClose(); // Close the drawer when the close icon is clicked
          markLocalSearchUpdate(search); // update the search state when drawer is closed
        }} type='button' aria-label='close-icon' className='text-grayText transition-colors hover:text-brand-dark'>
            <CloseIcon className='cursor-pointer' data-sentry-element="CloseIcon" data-sentry-source-file="MobileSearchDrawer.tsx" />
          </button>
        </div>
      </header>
      <main className='calender-mobile-scrollbar mx-auto flex max-h-[calc(100dvh-157px)] min-h-[490px] w-full flex-1 justify-center overflow-x-hidden overflow-y-scroll px-4 pt-2'>
        <div className='w-full'>
          {/* Accordion component for location search */}
          <LocationAccordian isSearchCleared={isSearchCleared} setIsSearchCleared={setIsSearchCleared} data-sentry-element="LocationAccordian" data-sentry-source-file="MobileSearchDrawer.tsx" />
          {/* Accordion component for calendar search */}
          <CalenderAccordian isDateCleared={isDateCleared} setIsDateCleared={setIsDateCleared} data-sentry-element="CalenderAccordian" data-sentry-source-file="MobileSearchDrawer.tsx" />
          <GuestAccordian data-sentry-element="GuestAccordian" data-sentry-source-file="MobileSearchDrawer.tsx" /> {/* Accordion component for guest search */}
        </div>
      </main>

      {/* Component for footer buttons */}
      <footer className='absolute bottom-0 z-[1] w-full bg-offWhite px-6 py-4 shadow-[0_-4px_7px_0_rgba(55,56,77,0.08)]'>
        <DrawerFooterButtons onClose={onClose} setIsSearchCleared={setIsSearchCleared} setIsDateCleared={setIsDateCleared} data-sentry-element="DrawerFooterButtons" data-sentry-source-file="MobileSearchDrawer.tsx" />
      </footer>
    </CVADrawer>;
};
export default MobileSearchDrawer;